import React, {useEffect} from 'react'
import '../CSS/Contact.css'
import Aos from "aos"
import "aos/dist/aos.css"
import TwitterIcon from '@material-ui/icons/Twitter';
import FacebookIcon from '@material-ui/icons/Facebook';
import InstagramIcon from '@material-ui/icons/Instagram';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import GitHubIcon from '@material-ui/icons/GitHub';
import MailIcon from '@material-ui/icons/Mail';
const Contact = () => {

   useEffect(() => {
      Aos.init({duration:2000});
   }, []);

    return (
   

       <>
        
        
         <div className="backContact">
            <div className="container col-10 mx-auto mb-2 mb-lg-0" >
            
            <div data-aos="fade-down" className="upper">
                  <h1>Suprodip Kundu</h1>
                  <h3>Let's build the Community &nbsp;&bull;&nbsp;You are here &nbsp;&bull;&nbsp; Down there is mine</h3>
               </div>
               <div className="iconBox">         
                  <i><a href = "https://twitter.com/iamsuprodip" target="blank"><TwitterIcon data-aos="fade-up" data-aos-delay="300" className="icon" style={{ fontSize: 70 }} /></a></i>
                  <i><a href = "https://www.facebook.com/suprodip.kundu" target="blank"><FacebookIcon data-aos="fade-up" data-aos-delay="400" className="icon" style={{ fontSize: 70 }}/></a></i>
                  <i><a href = "https://www.instagram.com/_pro.vider_/" target="blank"><InstagramIcon data-aos="fade-up" data-aos-delay="500" className="icon" style={{ fontSize: 70 }}/></a></i>
                 <i><a href = "https://www.linkedin.com/in/suprodip-kundu-05a185191/" target="blank"><LinkedInIcon data-aos="fade-up" data-aos-delay="600" className="icon" style={{ fontSize: 70 }}/></a></i>
                 <i><a href = "https://github.com/pro-vider" target="blank"><GitHubIcon data-aos="fade-up" data-aos-delay="700" className="icon" style={{ fontSize: 70 }}/></a></i>
                 <i><a href = "mailto:suprodipkundu718@gmail.com" target="blank"><MailIcon data-aos="fade-up" data-aos-delay="800" className="icon" style={{ fontSize: 70 }}/></a></i>
               </div>          
             
            </div>
         </div>
       </>
    )
}

export default Contact

